import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';
import { hideTooltip } from 'components/Graph/commands/pathLookup/hideTooltip';
import { setPathLookupPathInspectorHighlightedEdgeHovered } from 'components/Graph/commands/pathLookup/setPathLookupPathInspectorHighlightedEdgeHovered';
import { showPathLookupPathInspectorEdgeTooltip } from 'components/Graph/commands/pathLookup/showPathLookupPathInspectorEdgeTooltip';
import type PIXI from 'pixi.js';

export const pathLookupPathInspector: GraphRendererPlugin = (
  pluginInterface,
) => {
  pluginInterface.events.addListener('edgeAdded', (edgeEvent) => {
    const { edge, id } = edgeEvent;
    edge.on('mouseover', (event: PIXI.interaction.InteractionEvent) => {
      if (
        'offsetX' in event.data.originalEvent &&
        'offsetY' in event.data.originalEvent
      ) {
        // If edge is highlighted and path inspector is open, is checked in command
        pluginInterface.graphDispatch(showPathLookupPathInspectorEdgeTooltip, {
          edgeId: id,
          position: {
            x: event.data.originalEvent.offsetX,
            y: event.data.originalEvent.offsetY,
          },
        });
      }
      pluginInterface.graphDispatch(
        setPathLookupPathInspectorHighlightedEdgeHovered,
        {
          edgeId: id,
          hovered: true,
        },
      );
    });
    edge.on('mouseout', () => {
      pluginInterface.graphDispatch(hideTooltip, {
        type: 'pathLookupPathInspectorEdge',
      });
      pluginInterface.graphDispatch(
        setPathLookupPathInspectorHighlightedEdgeHovered,
        {
          edgeId: id,
          hovered: false,
        },
      );
    });
  });
};
